import { apiClient } from "@/services/api"
import { defineStore } from "pinia"
import { useAuthStore } from "@/store/authentication"

export const useSettingsRoleStore = defineStore("settingsRole", {
  state: () => ({
    allRoles: [],
    // A load attempt has finished, successfully or not. Before that, a role id that matches nothing
    // only means "not fetched yet" — which is not the same as "this role is gone" and must not be
    // presented as such.
    loaded: false,
  }),
  getters: {
    getAllRoles: state => state.allRoles,
    isLoaded: state => state.loaded,
  },
  actions: {
    setAllRoles(roles) {
      this.allRoles = roles
    },
    addRole(role) {
      this.allRoles.push(role)
    },
    _updateRole(newRole) {
      const updatedIndex = this.allRoles.findIndex(role => role.id == newRole.id)
      this.allRoles[updatedIndex].permissions = newRole.permissions
    },
    removeRole(id) {
      const removedIndex = this.allRoles.findIndex(role => role.id == id)
      this.allRoles.splice(removedIndex, 1)
    },
    loadAllRoles() {
      return apiClient
        .get("/role")
        .then(res => {
          this.setAllRoles(res.data)
        })
        .finally(() => {
          this.loaded = true
        })
    },
    saveNewRole(newRole) {
      return apiClient.post("/role", newRole).then(res => {
        if (res.status == 201) {
          this.addRole(res.data)
        }
        return res
      })
    },
    updateRole(newRole) {
      return apiClient
        .put(`/role/${newRole.id}`, newRole.permissions)
        .then(res => {
          if (res.status == 200) {
            // Update role in state
            this._updateRole(res.data)
          }
          return res
        })
        .then(res => {
          const authStore = useAuthStore()
          authStore.loadPrincipal()
          return res
        })
    },
    deleteRole(id) {
      return apiClient.delete(`/role/${id}`).then(res => {
        if (res.status == 200) {
          // Remove role from state
          this.removeRole(id)
        }
        return res
      })
    },
  },
})
